import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageViewTracker from "@/components/PageViewTracker";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import SignupSuccess from "@/pages/SignupSuccess";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Meds from "@/pages/Meds";
import Calendar from "@/pages/Calendar";
import Vitals from "@/pages/Vitals";
import Scribe from "@/pages/Scribe";
import Claims from "@/pages/Claims";
import Vault from "@/pages/Vault";
import Inbox from "@/pages/Inbox";
import Patients from "@/pages/Patients";
import Invite from "@/pages/Invite";
import Billing from "@/pages/Billing";
import Sessions from "@/pages/Sessions";
import PatientInvite from "@/pages/PatientInvite";
import FamilyInvite from "@/pages/FamilyInvite";
import Activate from "@/pages/Activate";
import Legal from "@/pages/Legal";
import LegalDoc from "@/pages/LegalDoc";
import Privacy from "@/pages/Privacy";
import Account from "@/pages/Account";
import Feature from "@/pages/Feature";

const P = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageViewTracker />
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/features/:slug" element={<Feature />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/success" element={<SignupSuccess />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/patient-invite/:token" element={<PatientInvite />} />
          <Route path="/family-invite/:token" element={<FamilyInvite />} />
          <Route path="/activate/:token" element={<Activate />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/legal/:slug" element={<LegalDoc />} />
          <Route path="/app" element={P(<Dashboard />)} />
          <Route path="/app/meds" element={P(<Meds />)} />
          <Route path="/app/calendar" element={P(<Calendar />)} />
          <Route path="/app/vitals" element={P(<Vitals />)} />
          <Route path="/app/scribe" element={P(<Scribe />)} />
          <Route path="/app/claims" element={P(<Claims />)} />
          <Route path="/app/vault" element={P(<Vault />)} />
          <Route path="/app/inbox" element={P(<Inbox />)} />
          <Route path="/app/patients" element={P(<Patients />)} />
          <Route path="/app/invite" element={P(<Invite />)} />
          <Route path="/app/billing" element={P(<Billing />)} />
          <Route path="/app/sessions" element={P(<Sessions />)} />
          <Route path="/app/privacy" element={P(<Privacy />)} />
          <Route path="/app/account" element={P(<Account />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
